import {create} from 'zustand';
export const useWordPressStore = create((set) => ({
    posts: null,
    pages: null,
    photosFromActions: null,
    videos: null,
    references: null,
    whatWeDo: null,
    socials: null,
    materials: null,
    categories: null,
    filesToDownload: null,
    setPosts: (posts) => set({ posts }),
    setPages: (pages) => set({ pages }),
    setPhotosFromActions: (photosFromActions) => set({ photosFromActions }),
    setVideos: (videos) => set({ videos }),
    setReferences: (references) => set({ references }),
    setWhatWeDo: (whatWeDo) => set({ whatWeDo }),
    setSocials: (socials) => set({ socials }),
    setMaterials: (materials) => set({ materials }),
    setCategories: (categories) => set({ categories }),
    setFilesToDownload: (filesToDownload) => set({ filesToDownload }),
}));